import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@thd-olt-component-react/alert';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { productShape } from '../../helpers/pod-fulfillment-utils';
import { CheckNearByStore } from './CheckNearbyStore';

export const LimitedAvailabilityInStockNearby = ({
  product,
  onCheckNearbyStoresClick
}) => {
  const { channel } = useContext(ExperienceContext);
  const { storeName, storeId } = useStore();

  if (!(storeName && storeId)) {
    return null;
  }

  // @TODO: Doesn't show "Check nearby stores" for stage: 303780504.
  // There is only 1 store, the anchor.
  const storeMessage = `Limited stock at ${storeName}`;

  return (
    <>
      <Alert type="warning" message={storeMessage} inline />
      {channel !== 'mobile' && (
        <div className="store__new-line">
          <CheckNearByStore
            product={product}
            onCheckNearbyStoresClick={onCheckNearbyStoresClick}
          />
        </div>
      )}
    </>
  );
};

LimitedAvailabilityInStockNearby.propTypes = {
  product: PropTypes.shape({ productShape }).isRequired,
  onCheckNearbyStoresClick: PropTypes.func.isRequired
};
